import React, {useState} from "react";

import "./index.scss";

const NoteTypeList = ({noteTypeListChange}) => {

    const [checkId, setCheckId] = useState('1');

    const [noteTypeList, setNoteTypeList] = useState([
        {id:"1", name:"知识体系管理"},
        {id:"2", name:"想法管理"},
        {id:"3", name:"书摘管理"},
    ]);

    useState(() => { 
        noteTypeListChange('1');
    }, [])

    const changeId = (id) => {
        setCheckId(id);
        noteTypeListChange(id);
    }

  return (
    <div className="noteTypeListFrameV7">
        <div className="scrollBox">
            {noteTypeList.map((item, index) => (
                <div key={item.id} className={`listItem ${checkId === item.id ? 'active':''}`} onClick={()=>changeId(item.id)}>{item.name}</div>
            ))}
        </div>
    </div>
  );
};

export default NoteTypeList;
